import mixpanel from 'mixpanel-browser';
import {
  isProductionWebAnalyticsRuntime,
  isViteEnvTrue,
  MIXPANEL_EVENTS,
  type MixpanelSite,
} from '@genie/shared/client';

const SITE: MixpanelSite = 'marketplace';

let initialized = false;

function isDevAnalyticsEnabled(): boolean {
  return isViteEnvTrue(import.meta.env.VITE_MIXPANEL_ENABLE_DEV);
}

function isEnabled(): boolean {
  const token = import.meta.env.VITE_MIXPANEL_TOKEN;
  if (!token?.trim()) return false;

  if (isProductionWebAnalyticsRuntime(import.meta.env.PROD)) return true;

  return isDevAnalyticsEnabled();
}

export function initMixpanel(): void {
  if (initialized || !isEnabled()) return;

  const token = import.meta.env.VITE_MIXPANEL_TOKEN!.trim();

  mixpanel.init(token, {
    track_pageview: false,
    persistence: 'localStorage',
    record_sessions_percent: 15,
    record_mask_all_inputs: true,
    record_idle_timeout_ms: 1_800_000,
  });

  mixpanel.register({
    site: SITE,
    app: 'marketplace-client',
  });

  initialized = true;
}

export function trackMixpanelPageView(pathname: string, search: string): void {
  if (!initialized) return;

  mixpanel.track(MIXPANEL_EVENTS.PAGE_VIEW, {
    site: SITE,
    path: pathname,
    search: search || undefined,
    url: `${pathname}${search}`,
  });
}

export function trackMixpanelEvent(
  eventName: string,
  properties?: Record<string, unknown>,
): void {
  if (!initialized) return;

  mixpanel.track(eventName, {
    site: SITE,
    ...properties,
  });
}

export { MIXPANEL_EVENTS };
